import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Input } from '../../widgets/input';
import { useSpaceStore } from '../../stores/space';

import styles from './spaces.module.css';
import { ReactComponent as WorldIcon } from './icons/world.svg';
import { ReactComponent as OfficeIcon } from './icons/office.svg';
import { ReactComponent as ArrowIcon } from './icons/arrow-right.svg';
import { ReactComponent as TickIcon } from './icons/tick.svg';

import { Space } from './space';
import { useUserStore } from '../../stores/user';

export function SpaceList(props){
    const { getAll, getByCode, spaces, create } = useSpaceStore();
    const { setOfficeId } = useUserStore();
    const navigate = useNavigate();
    const [showCreate, setShowCreate] = useState(false);
    
    const [createType, setCreateType] = useState('world');
    const [officeCode, setOfficeCode] = useState('');
    const [roomSize, setRoomSize] = useState(3);
    const [createName, setCreateName] = useState('');
    const [joinerrors, setJoinErrors] = useState([]);
    const [createerrors, setCreateErrors] = useState([]);
    useEffect(() => {
        getAll();
    }, [getAll]);
    return <div className={styles.container}>
        <div className={`${styles.spaces}  ${showCreate ? styles.showcreate : ''}`}>
            <h1>Create or Join an Office</h1>
            <form onSubmit={async e => {
                e.preventDefault();
                if(!officeCode){
                    setJoinErrors(['Office Id is required']);
                    return;
                }
                const space = await getByCode(officeCode);
                await setOfficeId(space.id);
                navigate(`/spaces/${space.id}`);
            }}>
                <Input type="text" id="officeid" label="#Office Id" value={officeCode} onChange={e => {
                    setOfficeCode(e.target.value);
                }} />
                {joinerrors.length > 0 && <div className={styles.errors}>{joinerrors.map(error => <span key={error}>{error}</span>)}</div>}
                <button className={styles.action}>Join an Existing Office</button>
            </form>
            <hr />
            <form onSubmit={async e => {
                e.preventDefault();
                if(!createName){
                    setCreateErrors(['Name is required']);
                    return;
                }
                const space = await create({
                    name: createName,
                    size: roomSize,
                });
                await setOfficeId(space.id);
                navigate(`/spaces/${space.id}`);
            }}>
                <Input type="text" id="officename" label="Office Name" value={createName} onChange={e => {
                    setCreateName(e.target.value);
                }} />
                <div className={styles.spacetypes}>
                    <button type="button" className={roomSize === 3 ? styles.checked : ''} onClick={e => {e.preventDefault();setRoomSize(3)}}>3x3 <TickIcon className={styles.tick} /></button>
                    <button className={roomSize === 5 ? styles.checked : ''} onClick={e => {e.preventDefault();setRoomSize(5)}}>5x5 <TickIcon className={styles.tick} /></button>
                    <button className={roomSize === 8 ? styles.checked : ''}  onClick={e => {e.preventDefault();setRoomSize(8)}}>8x8 <TickIcon className={styles.tick} /></button>
                    <button className={roomSize === 10 ? styles.checked : ''}  onClick={e => {e.preventDefault();setRoomSize(10)}}>10x10 <TickIcon className={styles.tick} /></button>
                </div>
                {createerrors.length > 0 && <div className={styles.errors}>{createerrors.map(error => <span key={error}>{error}</span>)}</div>}
                <button className={styles.action}>Create New Office</button>
            </form>

{/*             

            <button onClick={e => {
                setShowCreate(false)
            }}>Join an Existing Office</button>
            <button className={styles.createbutton} onClick={() => {
                setShowCreate(!showCreate);
            }}>Create Room</button>
            <div className={`${styles.spacelist}`}>
                {spaces.map(space => {
                    return <Link to={`/spaces/${space.id}`} className={styles.space} key={space.id}>
                        <h2>
                            {space.type === "world" ? <WorldIcon /> : <OfficeIcon />} 
                            {space.name}
                        </h2>
                        <span className={styles.roomcount}>{space.rooms || 0} rooms</span>
                        <ArrowIcon className={styles.arrow} />
                    </Link>
                })}
            </div> */}
            {/* <div className={styles.create}>
                <h2>Create a new space</h2>
                <form onSubmit={e => {
                    e.preventDefault();
                    e.stopPropagation();
                    create({
                        type: createType,
                        name: createName
                    });
                }}>
                    <Input type="text" id="name" label="Space Name" value={createName} onChange={e => {
                        setCreateName(e.target.value);
                    }} />
                    <div className={styles.spacetypes}>
                        <button className={createType === 'world'? styles.checked : ''} onClick={() => setCreateType('world')}><WorldIcon className={styles.typeicon} /> World <TickIcon className={styles.tick} /></button>
                        <button className={createType === 'office'? styles.checked : ''}  onClick={() => setCreateType('office')}><OfficeIcon className={styles.typeicon} /> Office <TickIcon className={styles.tick} /></button>
                    </div>
                    <div className={styles.actions}>
                        <button>Create</button>
                        <button onClick={e => {
                            setShowCreate(false)
                        }}>Cancel</button>
                    </div>
                </form>
            </div> */}
        </div>
    </div>
}

export { Space }